import { Action } from '@ngrx/store';
import { AssignmentGroup } from '../../types/assignments.types';

export enum AssignmentGroupsActions {
  Load = '[AssignmentGroups] Load',
  LoadSuccess = '[AssignmentGroups] Load Success',
  LoadFail = '[AssignmentGroups] Load Fail',
  Save = '[AssignmentGroups] Save',
  SaveSuccess = '[AssignmentGroups] Save Success',
  SaveFail = '[AssignmentGroups] Save Fail',
  Delete = '[AssignmentGroups] Delete',
  DeleteSuccess = '[AssignmentGroups] Delete Success',
  DeleteFail = '[AssignmentGroups] Delete Fail',
  Reset = '[AssignmentGroups] Reset'
}

export class LoadAssignmentGroups implements Action {
  public readonly type = AssignmentGroupsActions.Load;
}

export class LoadAssignmentGroupsSuccess implements Action {
  public readonly type = AssignmentGroupsActions.LoadSuccess;

  constructor(public payload: AssignmentGroup[]) {}
}

export class LoadAssignmentGroupsFail implements Action {
  public readonly type = AssignmentGroupsActions.LoadFail;

  constructor(public payload: string) {}
}

export class SaveAssignmentGroup implements Action {
  public readonly type = AssignmentGroupsActions.Save;
  constructor(public payload: AssignmentGroup) {}
}

export class SaveAssignmentGroupSuccess implements Action {
  public readonly type = AssignmentGroupsActions.SaveSuccess;

  constructor(public payload: AssignmentGroup) {}
}

export class SaveAssignmentGroupFail implements Action {
  public readonly type = AssignmentGroupsActions.SaveFail;
  constructor(public payload: any) {}
}

export class DeleteAssignmentGroup implements Action {
  public readonly type = AssignmentGroupsActions.Delete;

  constructor(public payload: string) {}
}

export class DeleteAssignmentGroupSuccess implements Action {
  public readonly type = AssignmentGroupsActions.DeleteSuccess;
}

export class DeleteAssignmentGroupFail implements Action {
  public readonly type = AssignmentGroupsActions.DeleteFail;

  constructor(public payload: string) {}
}

export class ResetAssignmentGroupsAction implements Action {
  public readonly type = AssignmentGroupsActions.Reset;
}

export type AssignmentGroupsActionsUnion =
  | LoadAssignmentGroups
  | LoadAssignmentGroupsSuccess
  | LoadAssignmentGroupsFail
  | SaveAssignmentGroup
  | SaveAssignmentGroupSuccess
  | SaveAssignmentGroupFail
  | DeleteAssignmentGroup
  | DeleteAssignmentGroupSuccess
  | DeleteAssignmentGroupFail
  | ResetAssignmentGroupsAction;
